import type { Check } from './types';

async function assertOk(res: Response): Promise<Response> {
  if (!res.ok) throw new Error(`API ${res.status}: ${await res.text()}`);
  return res;
}

export async function fetchState(from: string, to: string): Promise<{ checks: Check[] }> {
  const res = await fetch(`/api/state?from=${from}&to=${to}`);
  await assertOk(res);
  return res.json();
}

export async function postCheck(itemId: string, date: string): Promise<void> {
  const res = await fetch('/api/check', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ itemId, date }),
  });
  await assertOk(res);
}

export async function deleteCheck(itemId: string, date: string): Promise<void> {
  const res = await fetch('/api/check', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ itemId, date }),
  });
  await assertOk(res);
}
